export default __webpack_public_path__ + "static/media/cerrarSesion.6904b4b9.svg";